import { URLS } from '../../../consts/endpoints';
import store from '../../../store/store';
import checkIfIoTShouldBeShown from '../../../utils/checkIfIoTShouldBeShown';
import checkIfSimcardsShouldBeShown from '../../../utils/checkIfSimcardsShouldBeShown';
import { getData } from '../../../utils/http';

import {
  doesArrayHasLength,
  isDefined,
  isStringEmpty,
  isUndefined
} from '../../../utils/isDefined';
import { actions as reduxActions } from '../reducers';


const reloadClient = async id => {
  let client = void 0;

  if (
    isUndefined(id) ||
    isStringEmpty(id) ||
    isNaN(id)
  ) {
    return;
  }

  try {
    const response = await getData(
      `${URLS.CLIENTS}/${id}.json?include=partner`
    );

    client = response?.data;

    const hasCientSimcards = await checkIfSimcardsShouldBeShown(id);

    let hasCientIoTSubs = false;

    if (doesArrayHasLength(response?.data?.metadata?.account_ids)) {
      const rules = store.getState().auth?.user?.rules;

      if (isDefined(rules)) {
        hasCientIoTSubs = await checkIfIoTShouldBeShown(id, rules);
      }
    }

    client = { ...client, hasCientSimcards, hasCientIoTSubs };
  } finally {
    if (isDefined(client)) {
      store.dispatch(reduxActions.setSelectedClient(client));
    }
  }
};

export default reloadClient;
